export const PROMPT_RECOMMENDATIONS = 'prompt-recommendations';
export const QUICK_REPLIES = 'quick-replies';